<template>
  <div>
    <div class="mgb-20px has-text-right" v-if="isSynchro">
      <a @click="popInOpen=true" >
          <b-icon class="icon is-left mgr-10px"
            icon="autorenew" type="is-default" size="is-small"></b-icon>
          <span class="is-size-8 has-text-default is-underline">
            {{$t('catalogue.newProduct.produitSynchro')}}
          </span>
      </a>
      <b-modal :active="popInOpen" class="modal-popIn"
            has-modal-card :can-cancel="true" @close="popInOpen=false">
            <popup-synchro :objectPatrimoine="face" />
      </b-modal>
    </div>
    <div class="columns is-multiline">
      <div class="column is-12">
        <b-field :label="$t('catalogue.newProduct.codePanneau')"
        class="obligatoire">
          <b-input v-model="produit.produitFace.codePanneau" :disabled="isSynchro">
          </b-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field :label="$t('catalogue.newProduct.format')"
                class="obligatoire">
          <b-input v-model="produit.produitFace.format" :disabled="isSynchro">
          </b-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field :label="$t('catalogue.newProduct.materiel')">
          <b-input v-model="produit.produitFace.materielType" :disabled="isSynchro">
          </b-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field :label="$t('catalogue.newProduct.support')">
          <b-input v-model="produit.produitFace.support" :disabled="isSynchro">
          </b-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field :label="$t('catalogue.newProduct.localisation')">
          <b-input v-model="produit.produitFace.localisation" :disabled="isSynchro">
          </b-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field :label="$t('catalogue.newProduct.angleVision')">
          <b-input v-model="produit.produitFace.angleDeVision" :disabled="isSynchro">
          </b-input>
        </b-field>
      </div>
      <div class="column is-4">
        <gestion-azimut v-model="produit.produitFace.azimut"/>
      </div>
      <div class="column is-4 has-text-default">
        <qd-checkbox v-model="produit.produitFace.eclaire"
                    :class="{'pointer-events-none' : isSynchro}"
                    class="mgt-1em has-text-weight-bold">
          {{ $t('catalogue.newProduct.eclaire') }}
        </qd-checkbox>
      </div>
      <div class="column is-4 has-text-default">
        <qd-checkbox v-model="produit.produitFace.proposableLc"
                    :class="{'pointer-events-none' : isSynchro}"
                    class="mgt-1em has-text-weight-bold">
          {{ $t('catalogue.newProduct.proposableLc') }}
        </qd-checkbox>
      </div>
      <div class="column is-4 has-text-default">
        <qd-checkbox v-model="produit.produitFace.proposableReseau"
                    :class="{'pointer-events-none' : isSynchro}"
                    class="mgt-1em has-text-weight-bold">
          {{ $t('catalogue.newProduct.proposableReseau') }}
        </qd-checkbox>
      </div>
      <div class="column is-4" v-if="isSynchro">
        <b-field :label="$t('catalogue.newProduct.disposition')">
          <b-input v-model="produit.produitFace.disposition" :disabled="isSynchro">
          </b-input>
        </b-field>
      </div>
      <div class="column is-4" v-else>
        <b-field :label="$t('catalogue.newProduct.disposition')">
          <b-input v-model="produit.produitFace.disposition">
          </b-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field :label="$t('catalogue.newProduct.enVenantDe')">
          <b-input v-model="produit.produitFace.enVenantDe" :disabled="isSynchro">
          </b-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field :label="$t('catalogue.newProduct.enAllantVers')">
          <b-input  v-model="produit.produitFace.enAllantVers" :disabled="isSynchro">
          </b-input>
        </b-field>
      </div>
      <div class="column is-6 has-text-default">
        <parametre-autocomplete
          :label="$t('catalogue.newProduct.faceMotifNonCom')"
          :target="constantes.PARAMETRES_KEYS.faceMotifNonCom"
          :disabled="true"
          v-model="produit.produitFace.faceMotifNonComId"
          expanded
        />
      </div>
      <div class="column is-6 has-text-default">
        <b-field :label="$t('catalogue.newProduct.confrere')">
          <b-autocomplete
            :value="libelleConfrere"
            :disabled="isSynchro"
            :open-on-focus="false"
            :data="confreres"
            field="nomCommercial"
            :placeholder="$i18n.t('general.autocomplete.search')"
            @input="getConfrere"
            :loading="isFetching"
            @select="setConfrere">
            <template slot="empty">
              <div v-if="!isFetching">
                {{$t('general.autocomplete.noRslt')}}
              </div>
              <div v-else>
                {{$t('general.autocomplete.search')}}
              </div>
            </template>
          </b-autocomplete>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce';
import { createNamespacedHelpers } from 'vuex';
import popupSynchro from '@/components/catalogue/synchro/popupSynchro';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import getAllConfrere from '@/services/tiers/getAllConfrere';
import gestionAzimut from '@/components/general/gestionAzimut';
import parametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    produit: {
      type: Object,
      required: true,
    },
    face: {
      type: Object,
      required: false,
    },
  },
  components: {
    popupSynchro,
    gestionAzimut,
    parametreAutocomplete,
  },
  data() {
    return {
      popInOpen: false,
      confreres: [],
      libelleConfrere: null,
      isFetching: false,
      constantes: {
        PARAMETRES_KEYS,
      },
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    isSynchro() {
      return this.produit.produitFace.faceId != null;
    },
  },
  methods: {
    getConfrere: debounce(async function confrereData(text) {
      if (text === this.libelleConfrere) return;
      try {
        this.libelleConfrere = text;
        this.produit.tiersId = null;
        this.isFetching = true;
        this.confreres = await getAllConfrere({
          societeId: this.societeActiveId,
          nomCommercial: text,
        });
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw e;
      }
    }),
    setConfrere(newConfrere) {
      if (!newConfrere) return;
      this.libelleConfrere = newConfrere.nomCommercial;
      this.produit.tiersId = newConfrere.id;
    },
  },
  mounted() {
    this.libelleConfrere = this.produit.tiers ? this.produit.tiers.nomCommercial : null;
  },
};
</script>
